"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AdBug", {
  enumerable: true,
  get: function get() {
    return _adBug.AdBug;
  }
});
Object.defineProperty(exports, "ApplyNow", {
  enumerable: true,
  get: function get() {
    return _applyNow.ApplyNow;
  }
});
Object.defineProperty(exports, "ArticleHero", {
  enumerable: true,
  get: function get() {
    return _articleHero.ArticleHero;
  }
});
Object.defineProperty(exports, "BankingLeadFormEntryPoint", {
  enumerable: true,
  get: function get() {
    return _bankingLeadFormEntryPoint.BankingLeadFormEntryPoint;
  }
});
Object.defineProperty(exports, "Chiclet", {
  enumerable: true,
  get: function get() {
    return _chiclet.Chiclet;
  }
});
Object.defineProperty(exports, "DisclaimerAd", {
  enumerable: true,
  get: function get() {
    return _disclaimerAd.DisclaimerAd;
  }
});
Object.defineProperty(exports, "FeaturedPlacement", {
  enumerable: true,
  get: function get() {
    return _featuredPlacement.FeaturedPlacement;
  }
});
Object.defineProperty(exports, "FlexibleAdBug", {
  enumerable: true,
  get: function get() {
    return _flexibleAdBug.FlexibleAdBug;
  }
});
Object.defineProperty(exports, "GenericContainer", {
  enumerable: true,
  get: function get() {
    return _genericContainer.GenericContainer;
  }
});
Object.defineProperty(exports, "GraphQlMarketplaceComparisonTable", {
  enumerable: true,
  get: function get() {
    return _marketplaceComparisonTable.GraphQlMarketplaceComparisonTable;
  }
});
Object.defineProperty(exports, "GraphQlMarketplaceReviewLink", {
  enumerable: true,
  get: function get() {
    return _marketplaceReviewLink.GraphQlMarketplaceReviewLink;
  }
});
Object.defineProperty(exports, "GraphQlMarketplaceStarRating", {
  enumerable: true,
  get: function get() {
    return _graphqlMarketplaceStarRating.GraphQlMarketplaceStarRating;
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _image.Image;
  }
});
Object.defineProperty(exports, "LTOBanner", {
  enumerable: true,
  get: function get() {
    return _sofiLto.LTOBanner;
  }
});
Object.defineProperty(exports, "LTODetails", {
  enumerable: true,
  get: function get() {
    return _sofiLto.LTODetails;
  }
});
Object.defineProperty(exports, "LTOTopBanner", {
  enumerable: true,
  get: function get() {
    return _sofiLto.LTOTopBanner;
  }
});
Object.defineProperty(exports, "LandingHero", {
  enumerable: true,
  get: function get() {
    return _landingHero.LandingHero;
  }
});
Object.defineProperty(exports, "MarketplaceCta", {
  enumerable: true,
  get: function get() {
    return _marketplaceCta.MarketplaceCta;
  }
});
Object.defineProperty(exports, "NWAMatchEntryPoint", {
  enumerable: true,
  get: function get() {
    return _nwaMatchEntryPoint.NWAMatchEntryPoint;
  }
});
Object.defineProperty(exports, "NerdWalletTaxes", {
  enumerable: true,
  get: function get() {
    return _nerdwalletTaxes.NerdWalletTaxes;
  }
});
Object.defineProperty(exports, "PoweredByColumnTax", {
  enumerable: true,
  get: function get() {
    return _poweredByColumnTax.PoweredByColumnTax;
  }
});
Object.defineProperty(exports, "QuickFact", {
  enumerable: true,
  get: function get() {
    return _quickFact.QuickFact;
  }
});
Object.defineProperty(exports, "SofiLTOAnnouncementBanner", {
  enumerable: true,
  get: function get() {
    return _sofiLtoBanner.SofiLTOAnnouncementBanner;
  }
});
Object.defineProperty(exports, "StarRating", {
  enumerable: true,
  get: function get() {
    return _starRating.StarRating;
  }
});
Object.defineProperty(exports, "StaticTaxEntryPoint", {
  enumerable: true,
  get: function get() {
    return _staticTaxEntryPoint.StaticTaxEntryPoint;
  }
});
Object.defineProperty(exports, "TaxAnnouncementBanner", {
  enumerable: true,
  get: function get() {
    return _taxAnnouncementBanner.TaxAnnouncementBanner;
  }
});
Object.defineProperty(exports, "TaxDisclosureText", {
  enumerable: true,
  get: function get() {
    return _taxDisclosureText.TaxDisclosureText;
  }
});
Object.defineProperty(exports, "TaxInsights", {
  enumerable: true,
  get: function get() {
    return _taxInsights.TaxInsights;
  }
});
Object.defineProperty(exports, "TaxPopUp", {
  enumerable: true,
  get: function get() {
    return _taxPopUp.TaxPopUp;
  }
});
Object.defineProperty(exports, "TaxPricingChart", {
  enumerable: true,
  get: function get() {
    return _taxPricingChart.TaxPricingChart;
  }
});
Object.defineProperty(exports, "TaxStickyBanner", {
  enumerable: true,
  get: function get() {
    return _taxStickyBanner.TaxStickyBanner;
  }
});
Object.defineProperty(exports, "TaxValueProps", {
  enumerable: true,
  get: function get() {
    return _taxValueProps.TaxValueProps;
  }
});
Object.defineProperty(exports, "WealthMiniProductCard", {
  enumerable: true,
  get: function get() {
    return _wealthMiniProductCard.WealthMiniProductCard;
  }
});
Object.defineProperty(exports, "isSoFiOffer", {
  enumerable: true,
  get: function get() {
    return _sofiLtoUtils.isSoFiOffer;
  }
});
Object.defineProperty(exports, "launchAuthenticationPage", {
  enumerable: true,
  get: function get() {
    return _launchAuthentication.launchAuthenticationPage;
  }
});
Object.defineProperty(exports, "launchTaxRegistrationPage", {
  enumerable: true,
  get: function get() {
    return _launchAuthentication.launchTaxRegistrationPage;
  }
});
var _adBug = require("./components/ad-bug");
var _applyNow = require("./components/apply-now");
var _articleHero = require("./components/article-hero");
var _bankingLeadFormEntryPoint = require("./components/banking-lead-form-entry-point");
var _chiclet = require("./components/chiclet");
var _disclaimerAd = require("./components/disclaimer-ad");
var _featuredPlacement = require("./components/featured-placement");
var _flexibleAdBug = require("./components/flexible-ad-bug");
var _genericContainer = require("./components/generic-container");
var _marketplaceComparisonTable = require("./components/marketplace-comparison-table");
var _marketplaceReviewLink = require("./components/marketplace-review-link");
var _graphqlMarketplaceStarRating = require("./components/marketplace-star-rating/graphql-marketplace-star-rating");
var _image = require("./components/image");
var _landingHero = require("./components/landing-hero");
var _sofiLto = require("./components/sofi-lto");
var _marketplaceCta = require("./components/marketplace-cta");
var _nerdwalletTaxes = require("./components/nerdwallet-taxes");
var _nwaMatchEntryPoint = require("./components/nwa-match-entry-point");
var _poweredByColumnTax = require("./components/powered-by-column-tax");
var _quickFact = require("./components/quick-fact");
var _sofiLtoBanner = require("./components/sofi-lto-banner");
var _starRating = require("./components/star-rating");
var _staticTaxEntryPoint = require("./components/static-tax-entry-point");
var _taxAnnouncementBanner = require("./components/tax-announcement-banner");
var _taxDisclosureText = require("./components/tax-disclosure-text");
var _taxInsights = require("./components/tax-insights");
var _taxPopUp = require("./components/tax-pop-up");
var _taxPricingChart = require("./components/tax-pricing-chart");
var _taxStickyBanner = require("./components/tax-sticky-banner");
var _taxValueProps = require("./components/tax-value-props");
var _wealthMiniProductCard = require("./components/wealth-mini-product-card");
var _launchAuthentication = require("./lib/launch-authentication");
var _sofiLtoUtils = require("./lib/sofi-lto-utils");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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